import React from "react";
import "./FloatingContactButtons.css";

const FloatingContactButtons = () => {
    // Телефонният номер в международен формат за WhatsApp
    const whatsappNumber = "359885506682"; 
    // Телефонният номер в международен формат за Viber
    const viberNumber = "%2B359885506682";

    return (
        <div className="floating-buttons-container">
            {/* WhatsApp Бутон */}
            <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="float-btn whatsapp"
                title="Пиши ни във WhatsApp"
            >
                {/* Оригиналната икона на WhatsApp от FontAwesome */}
                <i className="fab fa-whatsapp social-icon"></i>
            </a>

            {/* Viber Бутон */}
            <a
                href={`viber://chat?number=${viberNumber}`}
                className="float-btn viber"
                title="Пиши ни във Viber"
            >
                {/* Оригиналната икона на Viber от FontAwesome */}
                <i className="fab fa-viber social-icon"></i>
            </a>
        </div>
    );
};

export default FloatingContactButtons;